




























































































































































































































































































































































import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Comments, { ResourceType } from "@/store/modules/Comments";
import Viewpoints from "@/store/modules/Viewpoints";
import { Observable, ZenObservable } from "zen-observable-ts";
import { API, graphqlOperation } from "aws-amplify";
import { onCreateThreadComment, onDeleteThreadComment, onUpdateThreadComment } from "@/graphql/subscriptions";
import Colors from "@/utils/Colors";
import Modelling from "@/store/modules/Modelling";
import _ from "lodash";
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { UpdateCommentInput } from "@/API";
import ExportGrowingTable from '@/views/FileExport/ExportGrowingTable.vue';
import ExportFixedTable from '@/views/FileExport/ExportFixedTable.vue';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import RevisionCommentPanels from "@/components/comments/RevisionCommentPanels.vue";
const commentsModule = getModule(Comments)
const choicesModule = getModule(Choices)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const modelling = getModule(Modelling);
const decisionsModule = getModule(Decisions)
const workspaceOptions = getModule(WorkspaceOptions)

@Component({
    components: {CardTitle, FactorValueDisplay, ExportGrowingTable, ExportFixedTable, RevisionCommentPanels}
})
export default class ThreadedCommentDisplay extends Vue {
    private colors = Colors.COLORS

    @Prop()
    name!: string

    @Prop({required: true})
    decisionId!: string;

    @Prop({required: true})
    resource!: {
        id: string | 'CONTENT',
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    secondaryResource!: {
        id: string | "WEIGHT",
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    tertiaryResource: {
        id: string,
        name?: string,
        type: ResourceType
    }

    @Prop({default: false, type: Boolean})
    showAllThreads!: boolean

    @Prop({default: false, type: Boolean})
    hover!: boolean

    // @Prop({default: false, type: Boolean})
    // show!: boolean

    private createCommentSubscriber: ZenObservable.Subscription[] | null = [];
    private deleteCommentSubscriber: ZenObservable.Subscription[] | null = [];
    private updateCommentSubscriber: ZenObservable.Subscription[] | null = [];

    private allComments: { [id: string]: any } = {}
    private newComment = '';
    private filterUsers=[];
    private filterTags=[]
    private replyingToCommentId: string | undefined;
    private loading = true;
    private submittingComment = false;
    private deletingComment = false;
    private showEdit = ""
    private show = false;
    private hoverTitle = ""
    private tags = ['concerns', 'suggestions', 'strengths', 'questions', 'weaknesses']
    private showContent = true;
    private commentTags = []
    private openPanels = [];
    private revisionView = true;
    private openPanelInc = 0;
    private closePanelInc = 0;
    @Ref()
    private commentForm: HTMLFormElement;

    @Ref()
    private dialog: HTMLDialogElement;

    get userProfiles() {
        return usersModule.userProfiles;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get userId(): string {
        if (this.currentUser) {
            return this.currentUser.userId;
        }
        return '';
    }

    get commentThreads() {
        return commentsModule.commentThreads
    }

    get generatedCommentId() {
        return Comments.generateId(this.resource.id, this.secondaryResource.id, this.tertiaryResource.id);
    }

    get factorResources() {
        return modelling.publishedModelFactorResources
    }

    get commentUsers() {
        let userList: {displayName:string, userId: string}[] = []
        for(let comment of Object.values(this.allComments).flat()) {
            if(!_.includes(userList, {displayName: this.getDisplayName(comment.userId), userId: comment.userId})) {
                userList.push({displayName: this.getDisplayName(comment.userId), userId: comment.userId})

            }
        }
        return userList
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    get choices() {
        return choicesModule.choices;
    }

    // mounted() {
    //     this.init()
    // }

    @Watch('generatedCommentId')
    onSettingChange() {
        this.init();
    }

    // @Watch('commentThreadId')
    // onCommentThreadIdChange(newVal: string, oldVal: string) {
    //     if (newVal && !oldVal) {
    //         this.setSubscribers();
    //     }
    // }

    private init() {
        this.filterUsers = [];
        this.allComments = {};
        this.unsubscribeSubscribers();
        if (!this.showAllThreads) {
            if (!this.userProfiles.hasOwnProperty(this.userId)) {
                usersModule.fetchUserProfiles([this.userId])
                    .then(() => this.loading = true)
            } else {
                this.loading = true
            }
        } else if (this.showAllThreads) {
            for(let factor of Object.values(this.factorResources)) {
                if(factor.groupTypeDefinition && factor.groupTypeDefinition.type === 'TABLE_GROWING') {
                    for(let index in  factor.childrenIds) {
                        this.loadComments(`${factor.id}-${index}`)
                    }
                }

                this.loadComments(factor.id)

                
               
            }
        }
        this.loading = false
    }

    private loadComments(factorId) {
        if(this.isFactorVisible(factorId) && commentsModule.commentThreads.hasOwnProperty(Comments.generateId(this.resource.id,this.secondaryResource.id, factorId))) {
                    commentsModule.getCommentThread({
                        decisionId: this.decisionId,
                        resourceId: this.resource.id,
                        secondaryResourceId: this.secondaryResource.id,
                        tertiaryResourceId: factorId
                    }).then((thread: any) => {
                        if (thread && thread.comments && thread.comments.items) {
                            this.setSubscribers(factorId);
                            let comment = thread.comments.items;
                            Vue.set(this.allComments, factorId, thread.comments.items)
                            // this.allComments[factor.id].push(...thread.comments.items)
                            let users = comment.map(c => c.userId)
                                .filter((el, i, arr) => arr.indexOf(el) === i)
                                .filter(uId => !this.userProfiles.hasOwnProperty(uId));
                            usersModule.fetchUserProfiles(users)
                                .then(() => {
                                //    this.loading = false;
                                })
                        }
                    });
                }
    }

    private setSubscribers(factorResourceId: string) {
        let commentThread = this.commentThreads[Comments.generateId(this.resource.id, this.secondaryResource.id, factorResourceId)]
        
        this.createCommentSubscriber = this.createCommentSubscriber.concat((API.graphql(graphqlOperation(onCreateThreadComment, {
            decisionId: this.decisionId,
            threadId: commentThread ? commentThread.id : null
        })) as Observable<object>)
            .subscribe({
                next: (onCreateCommentData: any) => {
                    if (onCreateCommentData.value && onCreateCommentData.value.data
                        && onCreateCommentData.value.data.onCreateThreadComment) {
                        let newComment = onCreateCommentData.value.data.onCreateThreadComment;
                        let index = this.allComments[factorResourceId].findIndex(c => c.id === newComment.id)
                        if (index > -1) {
                            // If the comment already exists, just update it
                            this.allComments[factorResourceId].splice(index, 1, newComment);
                        } else {
                            this.allComments[factorResourceId].splice(0, 0, newComment)
                        }
                    }

                }
            }))

        this.deleteCommentSubscriber = this.deleteCommentSubscriber.concat((API.graphql(graphqlOperation(onDeleteThreadComment, {
            decisionId: this.decisionId,
            threadId: commentThread ? commentThread.id : null
        })) as Observable<object>)
            .subscribe({
                next: (onDeleteThreadComment: any) => {
                    if (onDeleteThreadComment.value && onDeleteThreadComment.value.data
                        && onDeleteThreadComment.value.data.onDeleteThreadComment) {
                        let deletedComment = onDeleteThreadComment.value.data.onDeleteThreadComment;
                        let index = this.allComments[factorResourceId].findIndex(c => c.id === deletedComment.id)
                        if (index > -1) {
                            this.allComments[factorResourceId].splice(index, 1);
                        }
                        if (this.allComments[factorResourceId].length === 0) {
                            commentsModule.deleteCommentThread({
                                decisionId: commentThread.id.decisionId,
                                resourceId: commentThread.id.resourceId,
                                secondaryResourceId: commentThread.id.secondaryResourceId,
                                tertiaryResourceId: commentThread.id.tertiaryResourceId
                            })
                            delete this.allComments[factorResourceId]
                        }
                    }

                }
            }))

        this.updateCommentSubscriber = this.updateCommentSubscriber.concat((API.graphql(graphqlOperation(onUpdateThreadComment, {
            decisionId: this.decisionId,
            threadId: commentThread ? commentThread.id : null

        })) as Observable<object>)
            .subscribe({
                next: (onUpdateThreadComment: any) => {
                    if (onUpdateThreadComment.value && onUpdateThreadComment.value.data
                        && onUpdateThreadComment.value.data.onUpdateThreadComment) {
                        let updatedComment = onUpdateThreadComment.value.data.onUpdateThreadComment;
                        let index = this.allComments[factorResourceId].findIndex(c => c.id === updatedComment.id)
                        if (index > -1) {
                            this.allComments[factorResourceId].splice(index, 1, updatedComment);
                        }
                    }

                }
            }))
    }

    private unsubscribeSubscribers() {
        if (this.createCommentSubscriber != null) {
            this.createCommentSubscriber.forEach(x=> x.unsubscribe())
        }
        if (this.deleteCommentSubscriber != null) {
             this.deleteCommentSubscriber.forEach(x=> x.unsubscribe())
        }
        if (this.updateCommentSubscriber != null) {
             this.updateCommentSubscriber.forEach(x=> x.unsubscribe())
        }
        this.createCommentSubscriber = [];
        this.deleteCommentSubscriber = [];
        this.updateCommentSubscriber = [];
    }

    private getDisplayName(userId: string) {
        let user;
        if (userId === this.userId) {
            return 'You'
            // user = this.currentUser;
        } else {
            user = this.userProfiles[userId]
        }

        if (!user) {
            return null;
        }

        if (!user.first) {
            return user.email.split('@')[0];
        }

        let name = '';
        if (user.first) {
            name = name + user.first;
        }
        if (user.last) {
            name = name + ' ' + user.last;
        }
        return name;
    }

    private getUserAvatarName(userId: string) {
        let name = this.getDisplayName(userId)
        if (name) {
            return name.substring(0, 1);
        }
    }

    private getColor(userId: string) {
        if (userId === this.userId) {
            return 'indigo'
        }
        return this.colors[Object.keys(this.userProfiles).indexOf(userId)]

    }

    async addComment(factorResourceId: string) {
        // if (!this.commentForm.validate()) {
        //     return;
        // }

        if (this.newComment.trim().length == 0) {
            return;
        }


        this.submittingComment = true;
        let commentThread = this.commentThreads[Comments.generateId(this.resource.id, this.secondaryResource.id, factorResourceId )]
        let result = await commentsModule.commentOnThread({
            comment: this.newComment,
            decisionId: this.decisionId,
            resourceId: this.resource.id,
            secondaryResourceId: this.secondaryResource.id,
            tertiaryResourceId: factorResourceId,
            threadId: commentThread ? commentThread.id : '',
            tags: this.commentTags.length > 0 ? this.commentTags: null
        })
        this.allComments[factorResourceId].splice(0, 0, result);
        this.newComment = '';
        this.commentTags = [];
        this.submittingComment = false;
        this.showEdit = "";

    }

    private async addTaggedComment(payload: {comment: any, factorResourceId: string}) {

        let factorResourceId = _.cloneDeep(payload.factorResourceId)
        this.submittingComment = true;
        let commentThread = this.commentThreads[Comments.generateId(this.resource.id, this.secondaryResource.id, factorResourceId )]
        let result = await commentsModule.commentOnThread(payload.comment)
        this.allComments[factorResourceId].splice(0, 0, result);
        this.newComment = '';
        this.commentTags = [];
        this.submittingComment = false;
        this.showEdit = "";
    }

    async updateComment(tag: string, comment: UpdateCommentInput){
        console.log(tag)
        comment.tags.splice(comment.tags.indexOf(tag), 1)
        let result = await commentsModule.updateComment(comment)
    }

    get commentKeys() {
        let keys = Object.keys(this.allComments)
        keys = keys.sort((a,b)=> {
            if (a === 'M') {
                return -1;
            }
             if (b === 'M') {
                return 1;
            }
            if(a < b) {
                return -1
            }
            if(a > b) {
                return 1
            }
            if(a === b) {
                return 0
            }

        })
        return keys
    }

    get tagCommentKeys() {
         let keys = Object.keys(this.tagKeyedComments)
        keys = keys.sort((a,b)=> {
            if (a === 'M') {
                return -1;
            }
             if (b === 'M') {
                return 1;
            }
            if(a < b) {
                return -1
            }
            if(a > b) {
                return 1
            }
            if(a === b) {
                return 0
            }

        })
        return keys
    }


    async deleteComment(commentId: string) {
        this.deletingComment = true;
        await commentsModule.deleteComment({id: commentId})
        this.deletingComment = false;
    }


    private formatDate(date: Date) {
        let now = new Date();

        let time = date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

        let diff = now.getTime() - date.getTime();
        if (diff <= 86400000 && date.getDate() == now.getDate()) {
            return time + ' Today'
        }
        if (diff < (now.getHours() * 3600000) + 86400000) {
            return time + ' Yesterday'
        }
        return date.toDateString()
    }

    private convertStringIndexToNum(value: any) {
        return parseInt(value)
    }

    @Watch('show')
    private onChangeShow() {
        this.openPanels = []
        this.showContent = true;
        this.commentTags = []
        this.filterTags = []
        this.dialog.scrollTop = 0
        if(this.show) {
            this.loading = true;
            this.init()
        }
        else{
            this.unsubscribeSubscribers()
        }
    }

    get factorListTree() {
        return modelling.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptions.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptions.showNonListFactors;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return (
            //     this.contributingVisibility ||
            //     (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            // );
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    get isViewpointActive() {
        return viewpointsModule.activeViewpointId != null;
    }

    
    get filteredComments() {
        let filteredAllComments = {};

        for(let factorId of Object.keys(this.allComments)) {
            let commentList = []
            commentList = this.allComments[factorId].filter(comment=> this.filterTags.length > 0 ? this.filterTags.some(tag=> comment?.tags?.includes(tag)): true && this.filterUsers.length > 0 ? this.filterUsers.includes(comment.userId): true) || []
            if(commentList.length > 0)
                Vue.set(filteredAllComments, factorId, commentList)
        }

        return filteredAllComments
    }

    get allTags() {
       let tagList = []
        for(let comment of Object.values(this.allComments).flat()) {
            if(comment.tags && comment.tags.length > 0)
                tagList.push(...comment.tags)
        }
        _.uniq(tagList)
        return tagList
    }

    private removeRowIndex(id: string) {
        if(id.includes('-')) {
            return id.substring(0, id.indexOf('-'))
        }
        else 
            return id
    }

    private formatRowIndex(rowName: string) {
        if(rowName.includes('-')) {
            return parseInt(rowName.substring(rowName.indexOf('-')+1))+1
        } else
            return -10
    }

    private openAllPanels() {
        this.openPanelInc += 1;
        this.openPanels = Array.from(Array(Object.keys(this.filteredComments).length).keys());
    }

    private closeAllPanels() {
        this.closePanelInc += 1;
        this.openPanels = []
    }

    get tagKeyedComments() {
        let tempComments = {}
        // for(let comment of this.allComments) {
        //     if(comment.tags != null) {
        //         comment.tags.map(tag => tempComments[tag].push(comment))
        //     }
        // }
        for(let key of this.commentKeys) {
            let tempObject = {}
            this.allTags.map(tag => {
                let filteredArray = this.filteredComments[key].filter(comment => comment.tags && comment.tags.includes(tag))
                if(filteredArray.length > 0) {
                    Vue.set(tempObject, tag, filteredArray)

                }
                
            })
            if(!_.isEmpty(tempObject)) {
                Vue.set(tempComments, key, tempObject)

            }
            console.log(tempObject)
        }
        console.log(tempComments)
        return tempComments
    } 



}
